"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.map.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ServiceItem = _interopRequireDefault(require("./ServiceItem.vue"));
var _buildingSevice = require("@/api/building-sevice.api");
var BuildingAddServiceModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BuildingAddServiceModal, _Vue);
  var _super = (0, _createSuper2.default)(BuildingAddServiceModal);
  function BuildingAddServiceModal() {
    var _this;
    (0, _classCallCheck2.default)(this, BuildingAddServiceModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "search", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "services", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectedServices", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingSubmit", false);
    return _this;
  }
  (0, _createClass2.default)(BuildingAddServiceModal, [{
    key: "selectedActiveServices",
    get: function get() {
      return this.selectedServices.filter(function (e) {
        return e.buildingService.isActive;
      });
    }
  }, {
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return "";
    }
  }, {
    key: "handleClickService",
    value: function handleClickService(service) {
      var index = this.selectedServices.findIndex(function (e) {
        return e.id == service.id;
      });
      if (index == -1) {
        service.buildingService.isActive = true;
        this.selectedServices.push(service);
      } else {
        this.selectedServices[index].buildingService.isActive = !service.buildingService.isActive;
        this.selectedServices = (0, _toConsumableArray2.default)(this.selectedServices);
      }
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "handleChoose",
    value: function () {
      var _handleChoose = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var buildingServices, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // debugger;
                this.loadingSubmit = true;
                _context.prev = 1;
                buildingServices = this.selectedServices.map(function (e) {
                  return {
                    serviceId: e.id,
                    isActive: e.buildingService.isActive,
                    price: e.buildingService.price || 0
                  };
                });
                data = {
                  buildingId: this.buildingId,
                  buildingServices: buildingServices
                };
                _context.next = 6;
                return _buildingSevice.buildingServiceApi.create(data);
              case 6:
                this.visible = false;
                this.onSubmitOk();
                this.$notify({
                  title: "Thông báo",
                  message: "Chỉnh sửa danh sách dịch vụ thành công",
                  type: "success"
                });
              case 9:
                _context.prev = 9;
                this.loadingSubmit = false;
                return _context.finish(9);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 9, 12]]);
      }));
      function handleChoose() {
        return _handleChoose.apply(this, arguments);
      }
      return handleChoose;
    }()
  }, {
    key: "fetchServices",
    value: function () {
      var _fetchServices = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = true;
                _context2.next = 3;
                return _buildingSevice.buildingServiceApi.findAll({
                  buildingId: this.buildingId
                });
              case 3:
                res = _context2.sent;
                this.loading = false;
                this.services = res.data;
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function fetchServices() {
        return _fetchServices.apply(this, arguments);
      }
      return fetchServices;
    }()
  }, {
    key: "handleOpen",
    value: function handleOpen(selectedServices) {
      this.selectedServices = (0, _toConsumableArray2.default)(selectedServices);
      this.fetchServices();
      this.visible = true;
    }
  }]);
  return BuildingAddServiceModal;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], BuildingAddServiceModal.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], BuildingAddServiceModal.prototype, "onSubmitOk", null);
BuildingAddServiceModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ServiceItem: _ServiceItem.default
  }
})], BuildingAddServiceModal);
var _default = BuildingAddServiceModal;
exports.default = _default;